<!-- Dialog Header -->
<div mat-dialog-title class="transparent_bg pt-5 justify-content-center">
  <!-- Title shown when the type is RequestBody -->
  <h2 class="text-center" *ngIf="data.type == 'RequestBody'">
    {{"auditLogs.requestBody"|translate}}
  </h2>
  <!-- Title shown when the type is Response -->
  <h2 class="text-center" *ngIf="data.type == 'Response'">
    {{"auditLogs.requestResponse"|translate}}
  </h2>
</div>

<!-- Dialog Content -->
<mat-dialog-content class="mt-4">
  <!-- Section showing request date and action type -->
  <div class="fields-group mb-0">
    <h3 class="subtitle-form-3">
      {{"auditLogs.requestDate"|translate}}:<span>
        {{data.record.timestamp| date:'d MMM yyyy - h:mm a' | capitalizeMonth}}
      </span>
    </h3>
    <h3 class="subtitle-form-3">
      {{data.typeTitle ? data.typeTitle : ("activityLogs.actionType"|translate)}}:<span>
        {{data.record.actionType}}
      </span>
    </h3>
  </div>

  <!-- Loading spinner displayed while data is being fetched -->
  <div *ngIf="dataLoading" class="dataLoading">
    <mat-spinner class="m-auto" diameter="50"></mat-spinner>
  </div>

  <!-- Main content container displayed when data is loaded -->
  <ng-container *ngIf="!dataLoading">
    <!-- Copy to clipboard button -->
    <div class="d-flex justify-content-end">
      <button mat-raised-button class="btn-grey-F6" (click)="copyToClipboard()">
        <!-- SVG icon for copy action -->
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="18" viewBox="0 0 15 18">
          <path id="ic_copy_to_clipboard"
            d="M155.137-845.405a1.684,1.684,0,0,1-1.241-.511,1.7,1.7,0,0,1-.508-1.248v-11.077a1.7,1.7,0,0,1,.508-1.248,1.684,1.684,0,0,1,1.241-.511h8.114a1.684,1.684,0,0,1,1.241.511,1.7,1.7,0,0,1,.508,1.248v11.077a1.7,1.7,0,0,1-.508,1.248,1.684,1.684,0,0,1-1.241.511Zm0-1.459h8.114a.283.283,0,0,0,.2-.094.286.286,0,0,0,.093-.206v-11.077a.286.286,0,0,0-.093-.206.283.283,0,0,0-.2-.094h-8.114a.283.283,0,0,0-.2.094.286.286,0,0,0-.093.206v11.077a.286.286,0,0,0,.093.206A.283.283,0,0,0,155.137-846.865ZM151.749-842a1.684,1.684,0,0,1-1.241-.511,1.7,1.7,0,0,1-.508-1.248v-11.807a.708.708,0,0,1,.209-.52.7.7,0,0,1,.517-.209.7.7,0,0,1,.518.209.709.709,0,0,1,.208.52v11.807a.286.286,0,0,0,.093.206.283.283,0,0,0,.2.094h8.84a.7.7,0,0,1,.518.209.709.709,0,0,1,.208.52.708.708,0,0,1-.208.52.7.7,0,0,1-.518.21Zm3.089-4.865v0Z"
            transform="translate(-150 860)" fill="#6b6d85" />
        </svg>
        {{"auditLogs.copyToClipboard"|translate}}
      </button>
    </div>

    <!-- JSON data display -->
    <div class="json_card">
      <pre>{{ logData | prettyJson }}</pre>
    </div>
  </ng-container>
</mat-dialog-content>

<!-- Dialog Actions -->
<mat-dialog-actions class="justify-content-center align-items-center">
  <div class="actions mt-5">
    <!-- Copy to clipboard button -->
    <button mat-raised-button class="btn-grey-F6" (click)="copyToClipboard()">
      <svg xmlns="http://www.w3.org/2000/svg" width="15" height="18" viewBox="0 0 15 18">
        <path id="ic_copy_to_clipboard"
          d="M155.137-845.405a1.684,1.684,0,0,1-1.241-.511,1.7,1.7,0,0,1-.508-1.248v-11.077a1.7,1.7,0,0,1,.508-1.248,1.684,1.684,0,0,1,1.241-.511h8.114a1.684,1.684,0,0,1,1.241.511,1.7,1.7,0,0,1,.508,1.248v11.077a1.7,1.7,0,0,1-.508,1.248,1.684,1.684,0,0,1-1.241.511Zm0-1.459h8.114a.283.283,0,0,0,.2-.094.286.286,0,0,0,.093-.206v-11.077a.286.286,0,0,0-.093-.206.283.283,0,0,0-.2-.094h-8.114a.283.283,0,0,0-.2.094.286.286,0,0,0-.093.206v11.077a.286.286,0,0,0,.093.206A.283.283,0,0,0,155.137-846.865ZM151.749-842a1.684,1.684,0,0,1-1.241-.511,1.7,1.7,0,0,1-.508-1.248v-11.807a.708.708,0,0,1,.209-.52.7.7,0,0,1,.517-.209.7.7,0,0,1,.518.209.709.709,0,0,1,.208.52v11.807a.286.286,0,0,0,.093.206.283.283,0,0,0,.2.094h8.84a.7.7,0,0,1,.518.209.709.709,0,0,1,.208.52.708.708,0,0,1-.208.52.7.7,0,0,1-.518.21Zm3.089-4.865v0Z"
          transform="translate(-150 860)" fill="#6b6d85" />
      </svg>
      {{"auditLogs.copyToClipboard"|translate}}
    </button>
    <!-- Close button -->
    <button mat-raised-button matDialogClose color="primary">
      {{ "swalMsg.Ok" | translate }}
    </button>
  </div>
</mat-dialog-actions>
